import { render, staticRenderFns } from "./TraxUiSelectRemoteObject.vue?vue&type=template&id=01451976&scoped=true"
import script from "./TraxUiSelectRemoteObject.vue?vue&type=script&lang=js"
export * from "./TraxUiSelectRemoteObject.vue?vue&type=script&lang=js"
import style0 from "./TraxUiSelectRemoteObject.vue?vue&type=style&index=0&id=01451976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01451976",
  null
  
)

export default component.exports